import React from 'react';
import {Route, Redirect, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import InvoiceAccountGate from './InvoiceAccountGate';

const PrivateRoute = ({component: Component, ...rest}) => {
  const authDetails = useSelector(state => state?.auth?.authDetails);
  const location = useLocation();
  const requestedPath = `${location.pathname}${location.search}${location.hash}`;
  return (
    <Route
      {...rest}
      render={props =>
        authDetails ? (
          <Component {...props} />
        ) : location.pathname.startsWith('/invoices/') ? (
          <InvoiceAccountGate requestedPath={requestedPath} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: {from: requestedPath},
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
